import { render, staticRenderFns } from "./AccountActivatedForm.vue?vue&type=template&id=3355de7c&"
import script from "./AccountActivatedForm.vue?vue&type=script&lang=js&"
export * from "./AccountActivatedForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountActivatedForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports